import { connect } from 'react-redux';

import { RootState } from 'state/reducers';
import {
  selectCurrentUser,
  // selectPending,
  selectVerificationToken,
  signUpStepsActions,
} from 'state/signUpSteps';

import VerifyAccount from './VerifyAccount';

const { SEND_VERIFICATION_EMAIL_REQUEST } = signUpStepsActions;

const mapStateToProps = (state: RootState) => ({
  // pending: selectPending(state),
  currentUser: selectCurrentUser(state),
  // TODO: remove once email sending is sorted out
  verificationToken: selectVerificationToken(state),
});

const mapDispatchToProps = {
  sendVerificationEmail: SEND_VERIFICATION_EMAIL_REQUEST,
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyAccount);
